export default "__VITE_ASSET__CgiDvs6T__"